import { Button } from 'corso-admin-ui';
import { MediaThumbnail } from './MediaThumbnail';
import { MediaItem } from './types';

export function MediaThumbnails({
  items,
  activeIndex,
  onSelect,
  tone = 'light',
}: {
  items: MediaItem[];
  activeIndex?: number;
  onSelect: (index: number) => void;
  tone?: 'light' | 'dark';
}) {
  if (!items.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {items.map((item, index) => (
        <Button
          variant="ghost"
          key={item.src}
          onClick={() => onSelect(index)}
          icon
          pressed={index === activeIndex}
        >
          <MediaThumbnail src={item.src} alt={item.alt} tone={tone} />
          <span className="sr-only">{index + 1}</span>
        </Button>
      ))}
    </div>
  );
}
